// src/pages/LandingPage/Examples.jsx
import {
  Box,
  Container,
  Heading,
  SimpleGrid,
  Flex,
  Text,
  useColorModeValue
} from '@chakra-ui/react';
import ImageCompare from '../ImageCompare'; // Ajuste o caminho conforme necessário

const ExampleCard = ({ title, description, beforeImage, afterImage }) => {
  return (
    <Box
      borderRadius="lg"
      overflow="hidden"
      bg={useColorModeValue('white', 'gray.800')}
      boxShadow="md"
      transition="all 0.3s ease"
      _hover={{
        transform: 'translateY(-10px)',
        boxShadow: 'xl',
      }}
    >
      <Flex direction={{ base: 'column', sm: 'row' }}>
      <ImageCompare 
              beforeImage={beforeImage} // Substitua pelo caminho da sua imagem original
              afterImage={afterImage} // Substitua pelo caminho da versão desenho
            />
      </Flex>
      <Box p={6}>
        <Heading as="h3" size="md" color="brand.primary" mb={2}>
          {title}
        </Heading>
        <Text color={useColorModeValue('gray.600', 'gray.400')}>
          {description}
        </Text>
      </Box>
    </Box>
  );
};

const Examples = () => {
  return (
    <Box bg={useColorModeValue('white', 'gray.800')} py={20} id="exemplos">
      <Container maxW={'1200px'}>
        <Heading
          as="h2"
          fontSize={{ base: '3xl', md: '4xl' }}
          textAlign={'center'}
          mb={16}
          color="brand.primary"
        >
          Transforme suas memórias
        </Heading>

        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10}>
          <ExampleCard
            title="Eternize seu casamento"
            description="Transforme as fotos do dia mais especial em arte para colorir e reviver"
            beforeImage="/img/casamento_img_real.png"
            afterImage="/img/casamento_img_paint.png"
          />
          <ExampleCard
            title="Momentos em família"
            description="Transforme retratos de família em desenhos que conectam gerações"
            beforeImage="/img/familia_img_real.png"
            afterImage="/img/familia_img_paint.png"
          />
          <ExampleCard
            title="Destinos inesquecíveis"
            description="Transforme paisagens e momentos de viagens em arte para colorir"
            beforeImage="/img/original-photo.png"
            afterImage="/img/drawing-version.png"            
          />
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default Examples;